// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import BtnSelect from "./BtnSelect";
import FitTextToBounds from "../core/components/FitTextToBounds";
import LocaliseText from "../core/components/LocaliseText";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import UIButton from '../core/components/UIButton';
import { RelicName, RelicNameValues } from '../level/relics/relic';
import { GameDataHandler } from '../GameDataHandler';
/* END-USER-IMPORTS */

export default class RelicChest extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 589.5, y ?? 384);

    // chest
    const chest = scene.add.image(0, 0, "game-all", "chest.png");
    chest.scaleX = 1.33;
    chest.scaleY = 1.33;
    this.add(chest);

    // relicHelmetSelected
    const relicHelmetSelected = scene.add.image(249, -170, "game-all", "selected-helmet.png");
    relicHelmetSelected.visible = false;
    this.add(relicHelmetSelected);

    // relicMagnetSelected
    const relicMagnetSelected = scene.add.image(-259, -185, "game-all", "selected-magnet.png");
    relicMagnetSelected.visible = false;
    this.add(relicMagnetSelected);

    // relicWingsSelected
    const relicWingsSelected = scene.add.image(-6, -170, "game-all", "selected-wings.png");
    relicWingsSelected.visible = false;
    this.add(relicWingsSelected);

    // relicSkullSelected
    const relicSkullSelected = scene.add.image(-158, 6, "game-all", "selected-skull.png");
    relicSkullSelected.visible = false;
    this.add(relicSkullSelected);

    // relicBootsSelected
    const relicBootsSelected = scene.add.image(172, 3, "game-all", "selected-boots.png");
    relicBootsSelected.visible = false;
    this.add(relicBootsSelected);

    // relicHelmetSlot
    const relicHelmetSlot = scene.add.image(249, -170, "game-all", "slot-helmet.png");
    this.add(relicHelmetSlot);

    // relicWingsSlot
    const relicWingsSlot = scene.add.image(-6, -170, "game-all", "slot-wings.png");
    this.add(relicWingsSlot);

    // relicSkullSlot
    const relicSkullSlot = scene.add.image(-158, 8, "game-all", "slot-skull.png");
    this.add(relicSkullSlot);

    // relicBootsSlot
    const relicBootsSlot = scene.add.image(172, 9, "game-all", "slot-boots.png");
    this.add(relicBootsSlot);

    // relicMagnetSlot
    const relicMagnetSlot = scene.add.image(-259, -185, "game-all", "slot-magnet.png");
    relicMagnetSlot.tintTopLeft = 16773014;
    relicMagnetSlot.tintTopRight = 16773014;
    relicMagnetSlot.tintBottomLeft = 16773014;
    relicMagnetSlot.tintBottomRight = 16773014;
    this.add(relicMagnetSlot);

    // relicHelmet
    const relicHelmet = scene.add.image(249, -169, "game-all", "relic-helmet.png");
    relicHelmet.visible = false;
    this.add(relicHelmet);

    // relicMagnet
    const relicMagnet = scene.add.image(-259, -184, "game-all", "relic-magnet.png");
    relicMagnet.visible = false;
    this.add(relicMagnet);

    // relicWings
    const relicWings = scene.add.image(-6, -169, "game-all", "relic-wings.png");
    relicWings.visible = false;
    this.add(relicWings);

    // relicSkull
    const relicSkull = scene.add.image(-158, 7, "game-all", "relic-skull.png");
    relicSkull.visible = false;
    this.add(relicSkull);

    // relicBoots
    const relicBoots = scene.add.image(172, 4, "game-all", "relic-boots.png");
    relicBoots.visible = false;
    this.add(relicBoots);

    // infoBoard
    const infoBoard = scene.add.container(0, 254);
    this.add(infoBoard);

    // board
    const board = scene.add.image(-13, 10, "common", "holder-large.png");
    board.scaleX = 1.1;
    board.scaleY = 1.1;
    infoBoard.add(board);

    // btnSelect
    const btnSelect = new BtnSelect(scene, 300, 0);
    btnSelect.visible = false;
    infoBoard.add(btnSelect);

    // relicDescriptionText
    const relicDescriptionText = scene.add.text(-13, 4, "", {});
    relicDescriptionText.setOrigin(0.5, 0.5);
    relicDescriptionText.text = "Track down the legendary Relics to unleash their magical powers on your next Treasure Rush!";
    relicDescriptionText.setStyle({ "align": "center", "fixedWidth":620,"fontSize": "40px" });
    relicDescriptionText.setWordWrapWidth(620, true);
    infoBoard.add(relicDescriptionText);

    // holder_thin_png
    const holder_thin_png = scene.add.image(-2, -575, "common", "holder-thin.png");
    holder_thin_png.scaleX = 0.9;
    holder_thin_png.scaleY = 0.9;
    infoBoard.add(holder_thin_png);

    // relicNameText
    const relicNameText = scene.add.text(-6, -578, "", {});
    relicNameText.setOrigin(0.5, 0.5);
    relicNameText.text = "No Relic Selected";
    relicNameText.setStyle({ "align": "center", "fontSize": "50px" });
    infoBoard.add(relicNameText);

    // relicDescriptionText (components)
    const relicDescriptionTextFitTextToBounds = new FitTextToBounds(relicDescriptionText);
    relicDescriptionTextFitTextToBounds.MaxHeight = 150;
    relicDescriptionTextFitTextToBounds.MultiLine = true;
    const relicDescriptionTextLocaliseText = new LocaliseText(relicDescriptionText);
    relicDescriptionTextLocaliseText.isDynamic = true;

    // relicNameText (components)
    const relicNameTextFitTextToBounds = new FitTextToBounds(relicNameText);
    relicNameTextFitTextToBounds.MaxWidth = 525;
    const relicNameTextLocaliseText = new LocaliseText(relicNameText);
    relicNameTextLocaliseText.isDynamic = true;

    this.relicHelmetSelected = relicHelmetSelected;
    this.relicMagnetSelected = relicMagnetSelected;
    this.relicWingsSelected = relicWingsSelected;
    this.relicSkullSelected = relicSkullSelected;
    this.relicBootsSelected = relicBootsSelected;
    this.relicHelmetSlot = relicHelmetSlot;
    this.relicWingsSlot = relicWingsSlot;
    this.relicSkullSlot = relicSkullSlot;
    this.relicBootsSlot = relicBootsSlot;
    this.relicMagnetSlot = relicMagnetSlot;
    this.relicHelmet = relicHelmet;
    this.relicMagnet = relicMagnet;
    this.relicWings = relicWings;
    this.relicSkull = relicSkull;
    this.relicBoots = relicBoots;
    this.infoBoard = infoBoard;
    this.board = board;
    this.btnSelect = btnSelect;
    this.relicDescriptionText = relicDescriptionText;
    this.relicNameText = relicNameText;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    this.relicNameToRelicSlotImage = {
      [RelicName.BronzeBoots]: this.relicBootsSlot,
      [RelicName.DiamondSkull]: this.relicSkullSlot,
      [RelicName.GoldenWings]: this.relicWingsSlot,
      [RelicName.PlatinumMagnet]: this.relicMagnetSlot,
      [RelicName.SilverHelmet]: this.relicHelmetSlot
    };

    this.relicNameToRelicImage = {
      [RelicName.BronzeBoots]: this.relicBoots,
      [RelicName.DiamondSkull]: this.relicSkull,
      [RelicName.GoldenWings]: this.relicWings,
      [RelicName.PlatinumMagnet]: this.relicMagnet,
      [RelicName.SilverHelmet]: this.relicHelmet
    };

    this.relicNameToRelicSelectedImage = {
      [RelicName.BronzeBoots]: this.relicBootsSelected,
      [RelicName.DiamondSkull]: this.relicSkullSelected,
      [RelicName.GoldenWings]: this.relicWingsSelected,
      [RelicName.PlatinumMagnet]: this.relicMagnetSelected,
      [RelicName.SilverHelmet]: this.relicHelmetSelected
    };

    this.hasRelics = false;
    this.noSelectionCopy = this.hasRelics ? 'noRelicSelected' : 'noRelics';
    this.infoBoard.setVisible(false);

    // this.relicNameText.setStyle({ rtl: true });
    // this.relicDescriptionText.setStyle({ rtl: true });
    /* END-USER-CTR-CODE */
  }

  private relicHelmetSelected: Phaser.GameObjects.Image;
  private relicMagnetSelected: Phaser.GameObjects.Image;
  private relicWingsSelected: Phaser.GameObjects.Image;
  private relicSkullSelected: Phaser.GameObjects.Image;
  private relicBootsSelected: Phaser.GameObjects.Image;
  private relicHelmetSlot: Phaser.GameObjects.Image;
  private relicWingsSlot: Phaser.GameObjects.Image;
  private relicSkullSlot: Phaser.GameObjects.Image;
  private relicBootsSlot: Phaser.GameObjects.Image;
  private relicMagnetSlot: Phaser.GameObjects.Image;
  private relicHelmet: Phaser.GameObjects.Image;
  private relicMagnet: Phaser.GameObjects.Image;
  private relicWings: Phaser.GameObjects.Image;
  private relicSkull: Phaser.GameObjects.Image;
  private relicBoots: Phaser.GameObjects.Image;
  private infoBoard: Phaser.GameObjects.Container;
  private board: Phaser.GameObjects.Image;
  private btnSelect: BtnSelect;
  private relicDescriptionText: Phaser.GameObjects.Text;
  private relicNameText: Phaser.GameObjects.Text;

  /* START-USER-CODE */
  public static events = {
    RelicSelected: 'relicSelected',
    RelicChosen: 'relicChosen'
  } as const;

  protected relicNameToRelicSlotImage: { [key in RelicNameValues]?: Phaser.GameObjects.Image };
  protected relicNameToRelicImage: { [key in RelicNameValues]?: Phaser.GameObjects.Image };
  protected relicNameToRelicSelectedImage: { [key in RelicNameValues]?: Phaser.GameObjects.Image };
  protected selectedRelic: RelicNameValues | undefined;
  protected previousSelectedRelic: RelicNameValues | undefined;
  protected newRelicDelay: number = 1800;
  protected hasRelics: boolean;
  protected noSelectionCopy: string;

  get SelectedRelic(): RelicNameValues | undefined {
    return this.selectedRelic;
  }

  public showRelics(relics: RelicNameValues[], newRelics: RelicNameValues[], activeRelics: RelicNameValues[], areInteractive: boolean, areSelected: boolean) {
    // if (relics.length > 0) {
    //   for (const relicName of relics) {
    //     this.showCollectedRelic(relicName, newRelics, areInteractive, areSelected);
    //   }
    //   // relics.forEach((relicName) => this.showRelic(relicName, newRelics, areInteractive, areSelected));
    // }
    GameDataHandler.clearNewRelics(this.scene);

    if (areInteractive) {
      this.scene.input.on(Phaser.Input.Events.POINTER_UP, () => {
        this.onNoRelicSelected(this.noSelectionCopy);
      });
      if (activeRelics.length == 0) this.onNoRelicSelected(this.noSelectionCopy);
    }

    for (const relicName of Object.values(RelicName)) {
      if (relics.includes(relicName)) {
        this.showCollectedRelic(relicName, newRelics, areInteractive, areSelected);

        if (areInteractive && activeRelics.includes(relicName)) {
          this.onRelicSelected(relicName);
        }
      } else if (areInteractive) {
        this.showUncollectedRelic(relicName);
      }
    }

    if (newRelics.length > 0) {
      this.scene.time.delayedCall(this.newRelicDelay, () => {
        app.audioHandler.playSound(this.scene, 'SndRelicUnlock', 'sfx');
      });
    }
  }

  protected awake() {
    this.hasRelics = (this.scene.game.registry.get(GameDataHandler.keys.CollectedRelics) as RelicNameValues[]).length > 0;
    this.noSelectionCopy = this.hasRelics ? 'noRelicSelected' : 'noRelics';

    // Btn moved to scene from prefab.
    // this.btnSelect.on(UIButton.events.clicked, () => {
    //   this.emit(RelicChest.events.RelicChosen, this.selectedRelic);
    // });
  }

  protected showCollectedRelic(relicName: RelicNameValues, newRelics: RelicNameValues[], isInteractive: boolean, isSelected: boolean) {
    let relic = this.relicNameToRelicImage[relicName];
    if (!relic) return;

    relic.setVisible(true);

    if (isInteractive) {
      relic.setInteractive();

      // relic.on(Phaser.Input.Events.POINTER_OVER, (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
      //   this.onRelicSelected(relicName);
      //   event.stopPropagation();
      // });

      // relic.on(Phaser.Input.Events.POINTER_OUT, () => {
      //   if (this.previousSelectedRelic) {
      //     this.onRelicSelected(this.previousSelectedRelic);
      //   } else {
      //     let hasRelics = (this.scene.game.registry.get(GameDataHandler.keys.CollectedRelics) as RelicNameValues[]).length > 0;
      //     let noSelectionCopy = hasRelics ? 'noRelicSelected' : 'noRelics';
      //     this.onNoRelicSelected(noSelectionCopy);
      //   }
      // });

      relic.on(Phaser.Input.Events.POINTER_UP, (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
        if (this.selectedRelic == relicName) {
          this.onNoRelicSelected(this.noSelectionCopy);
        } else {
          this.onRelicSelected(relicName);
          event.stopPropagation();
        }
      });
    }

    if (isSelected) this.setRelicSelectionState(relicName, true);

    console.log(`Relic ${relicName}, ${newRelics}`);
    if (newRelics.includes(relicName)) {
      console.log(`Relic 2 ${relicName}, ${newRelics}`);
      relic.scale = 0;
      this.scene.add.tween({
        targets: relic,
        scaleX: 1,
        scaleY: 1,
        duration: 1000,
        ease: Phaser.Math.Easing.Bounce.Out,
        delay: this.newRelicDelay
      });
      this.newRelicDelay += 200;
    }
  }

  protected showUncollectedRelic(relicName: RelicNameValues) {
    let slot = this.relicNameToRelicSlotImage[relicName];
    if (!slot) return;

    slot.setInteractive();

    slot.on(Phaser.Input.Events.POINTER_OVER, (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
      if (this.selectedRelic) this.setRelicSelectionState(this.selectedRelic, false);

      this.setRelicSelectionState(relicName, true);

      this.infoBoard.setVisible(true);
      this.relicNameText.setText(app.localeHandler.getLocalisedTextById(relicName, { useRTLFix: true }));
      this.relicDescriptionText.setText(app.localeHandler.getLocalisedTextById(relicName + 'Description', { useRTLFix: true }));
      // this.btnSelect.setVisible(false);

      this.previousSelectedRelic = this.selectedRelic;
      this.selectedRelic = relicName;

      event.stopPropagation();
    });

    slot.on(Phaser.Input.Events.POINTER_OUT, () => {
      if (this.previousSelectedRelic) {
        this.onRelicSelected(this.previousSelectedRelic);
      } else {
        this.onNoRelicSelected(this.noSelectionCopy);
      }
    });

    slot.on(Phaser.Input.Events.POINTER_UP, (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
      event.stopPropagation();
    });

    // slot.on(Phaser.Input.Events.POINTER_UP, (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
    //   if (this.selectedRelic) this.setRelicSelectionState(this.selectedRelic, false);

    //   this.setRelicSelectionState(relicName, true);

    //   this.infoBoard.setVisible(true);
    //   this.relicNameText.setText(app.localeHandler.getLocalisedTextById(relicName));
    //   this.relicDescriptionText.setText(app.localeHandler.getLocalisedTextById(relicName + 'Description'));
    //   this.btnSelect.setVisible(false);

    //   this.previousSelectedRelic = this.selectedRelic;
    //   this.selectedRelic = relicName;

    //   event.stopPropagation();
    // });
  }

  protected onNoRelic() {
    if (this.selectedRelic) this.setRelicSelectionState(this.selectedRelic, false);

    this.infoBoard.setVisible(true);
    this.relicNameText.setText(app.localeHandler.getLocalisedTextById('noRelics', { useRTLFix: true }));
    this.relicDescriptionText.setText(app.localeHandler.getLocalisedTextById('noRelicsDescription', { useRTLFix: true }));
    // this.btnSelect.setVisible(true);

    this.previousSelectedRelic = this.selectedRelic;
    this.selectedRelic = undefined;
  }

  protected onNoRelicSelected(copyId: string) {
    if (this.selectedRelic) this.setRelicSelectionState(this.selectedRelic, false);

    this.infoBoard.setVisible(true);
    this.relicNameText.setText(app.localeHandler.getLocalisedTextById(copyId, { useRTLFix: true }));
    this.relicDescriptionText.setText(app.localeHandler.getLocalisedTextById(copyId + 'Description', { useRTLFix: true }));
    // this.btnSelect.setVisible(true);

    this.previousSelectedRelic = this.selectedRelic;
    this.selectedRelic = undefined;
  }

  protected onRelicSelected(relicName: RelicNameValues) {
    if (this.selectedRelic) this.setRelicSelectionState(this.selectedRelic, false);

    this.setRelicSelectionState(relicName, true);
    this.infoBoard.setVisible(true);
    this.relicNameText.setText(app.localeHandler.getLocalisedTextById(relicName, { useRTLFix: true }));
    this.relicDescriptionText.setText(app.localeHandler.getLocalisedTextById(relicName + 'Description', { useRTLFix: true }));
    // this.btnSelect.setVisible(true);

    this.emit(RelicChest.events.RelicSelected, relicName);
    this.previousSelectedRelic = this.selectedRelic;
    this.selectedRelic = relicName;
  }

  protected setRelicSelectionState(relicName: RelicNameValues, state: boolean) {
    let relicSelect = this.relicNameToRelicSelectedImage[relicName];
    if (relicSelect) {
      relicSelect.setVisible(state);
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
